import {useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';
import {trackPageView} from '../../utils/analytics';

const AnalyticsTracker = () => {
  const location = useLocation ();
  const lastTrackedPath = useRef (null);

  useEffect (
    () => {
      const path = `${location.pathname}${location.search}`;

      // Prevent duplicate page views in React StrictMode during development
      if (lastTrackedPath.current === path) return;

      lastTrackedPath.current = path;

      trackPageView ({
        path,
        title: document.title,
      });
    },
    [location]
  );

  return null;
};

export default AnalyticsTracker;

